module.exports = __webpack_public_path__ + "images/emoji/tent.9ac42ddd401c89e23a6e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tent.png
// module id = CD1O
// module chunks = 24